import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { RoomTypeContainer } from '../../containers/filters/RoomTypeContainer';

export const roomType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Flat),
  component: RoomTypeContainer,
};
